import React from 'react';
import { Link as GatsbyLink } from 'gatsby';
import { Grid, Button, Theme, Typography } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';

import { Seo, Hero, Lazy } from '../components';
import { FC } from '../util';
import HeroWImage from '../components/hero/heroWImage';
import ProductList from '../components/productList';

const useStyles = makeStyles((theme: Theme) => ({
    heroButtons: {
        marginTop: theme.spacing(4)
    },
    images: {
        paddingBottom: theme.spacing(4),
        textAlign: 'center'
    },
    products: {
        maxWidth: 300,
        maxHeight: 300
    },
    text: {
        paddingBottom: theme.spacing(4)
    },
    image: {
        objectFit: 'contain',
        maxHeight: '100%',
        maxWidth: '100%'
    }
}));

const IndexPage: FC = () => {
    const styles = useStyles();
    return (
        <>
            <Seo title="Home" />
            <Lazy type="grow" delay={500} timeout={1000} mountOnEnter unmountOnExit>
                <HeroWImage
                    title="Your solution for clean water."
                    description="SLS Water is the professional choice for your water purification system solution, be it at home or on industrial premises."
                ></HeroWImage>
            </Lazy>
            <Lazy type="grow" delay={500} timeout={1000} mountOnEnter unmountOnExit>
                <Hero title="Our Products">
                    <div className={styles.heroButtons}>
                        <Grid container spacing={2} justify="center">
                            <ProductList />
                            <Grid>
                                <Button
                                    component={GatsbyLink}
                                    to="/products/"
                                    variant="contained"
                                    color="primary"
                                >
                                    Learn more
                                </Button>
                            </Grid>
                        </Grid>
                    </div>
                </Hero>
            </Lazy>
            <Lazy type="grow" delay={500} timeout={1000} mountOnEnter unmountOnExit>
                <Hero title="Our Partners">
                    <div className={styles.heroButtons}>
                        <Grid container spacing={2} justify="center">
                            <Grid item md={4}>
                                <Lazy type="slide" direction="left" delay={500}>
                                    <div className={styles.images}>
                                        <img src="/partner-1.png" />
                                    </div>
                                </Lazy>
                            </Grid>
                            <Grid item md={4}>
                                <Lazy type="slide" direction="left" delay={500}>
                                    <div className={styles.images}>
                                        <img src="/partner-3.png" />
                                    </div>
                                </Lazy>
                            </Grid>
                            <Grid item md={4}>
                                <Lazy type="slide" direction="left" delay={500}>
                                    <div className={styles.images}>
                                        <img src="/partner-4.png" />
                                    </div>
                                </Lazy>
                            </Grid>
                            <Grid>
                                <Typography align="center" className={styles.text}>
                                    Incorporated into every Omnipure filter body design are
                                    engineering features that make Omnipure products the best, most
                                    cost-effective inline water filters on the market. For instance,
                                    every filter features a patented spring disc that keeps media
                                    under ideal pressure and eliminates channeling. Polypropylene
                                    inlet and outlet pads prevent media migration that can foul
                                    water.
                                </Typography>
                            </Grid>
                        </Grid>
                    </div>
                </Hero>
            </Lazy>
        </>
    );
};

export default IndexPage;
